import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Divider, Link, Typography } from '@mui/material';
import classNames from 'classnames';
import { setupCurrentOriginUrl } from 'utils/contentUtils';
import useMobileMainMenu from './useMobileMainMenu';

const MobileMainMenu = ({ items, backLabel }) => {
  const { showBackButton, currentItems, onItemClick, onBackClick } = useMobileMainMenu(items);

  if (!Array.isArray(currentItems) && !showBackButton) {
    return null;
  }
  return (
    <div className="w-100">
      {showBackButton && (
        <>
          <Link
            href="#"
            color="black"
            className="py-2 d-flex align-items-center gap-1"
            underline="none"
            onClick={onBackClick}
          >
            <KeyboardArrowLeftIcon />
            <Typography component="span" variant="h6" color="inherit">
              {backLabel}
            </Typography>
          </Link>
          <Divider className="w-100 opacity-100" />
        </>
      )}
      {currentItems.map((it) => {
        const itemLink = setupCurrentOriginUrl(it.url);
        const hasLink = itemLink != null;
        const hasElements = Array.isArray(it.list) && it.list.length > 0;
        return (
          <div key={it.id}>
            <Link
              color="black"
              className={classNames('py-2 d-flex align-items-center justify-content-between', {
                activeLink: hasLink,
                hasElements: hasElements,
              })}
              href={itemLink ?? '#'}
              underline={hasLink && !hasElements ? 'hover' : 'none'}
              onClick={(e) => onItemClick(e, it)}
            >
              <Typography component="span" variant={hasLink && !hasElements ? 'body1' : 'subtitle1'} color="inherit">
                {it.label}
              </Typography>
              {hasElements && <KeyboardArrowRightIcon />}
            </Link>
            <Divider className="w-100 opacity-100" />
          </div>
        );
      })}
    </div>
  );
};
export default MobileMainMenu;
